import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { performPostRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';

const SET_GLOBAL_SCOPE_USER_PREFERENCE_MUTATION = `
    mutation SetGlobalScopeUserPreferenceMutation($input: SetMyPreferenceInput!) {
        setMyPreference(input: $input) {
            success
        }
    }
`;

const setGlobalScopeUserPreference = async (input: { key: string; value: string | boolean }) => {
	const result = await performPostRequest('/rest/gira/1/', {
		body: JSON.stringify({
			query: SET_GLOBAL_SCOPE_USER_PREFERENCE_MUTATION,
			variables: {
				input,
			},
		}),
	});

	if (result.data.setMyPreference.success !== true) {
		throw new Error(`Error setting user preference: ${input.key}`, {
			cause: result.errors?.[0],
		});
	}
};

export const setIsGlobalScopeEnrolmentEnabledUserPreference = async (value: boolean) =>
	setGlobalScopeUserPreference({
		key: 'jira.user.nin.global.scope.enrolment',
		value: value ? 'nin' : 'gin',
	});

export const resetGlobalScopeForcedOptOutGinFlag = async () =>
	setGlobalScopeUserPreference({
		key: 'jira.user.nin.global.scope.enrolment.flag.disabled',
		value: false,
	}).catch((error) =>
		fireErrorAnalytics({
			meta: {
				id: 'resetGlobalScopeGinFlag',
				packageName: 'jiraIssueNavigatorGlobalScopeEnrolment',
				teamName: 'empanada',
			},
			error,
			sendToPrivacyUnsafeSplunk: true,
		}),
	);
